<template>
    <div>
        <v-container grid-list-xs>
            <template>
                <v-toolbar flat color="white">
                    
                    <v-toolbar-title>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>
                    <v-btn class="font-weight-light" tile color="black" dark 
                        @click="btn_add">
                        <v-icon >add</v-icon>Receive
                    </v-btn>                    
                </v-toolbar>
            </template>
        </v-container>
        
        <v-container grid-list-xs>
            <v-data-table
                class="table"
                :headers="headers"
                :items="users"
                :search="search"
                :sort-by="[{ key: 'date', order: 'desc' }]"
                :rows-per-page-items="[10, 25]">
                <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.date }}</td>
                <td class="text-xs-left">{{ props.item.docno }}</td>                
                <td class="text-xs-left">{{ props.item.count_sku }}</td>
                <td class="text-xs-left">{{ props.item.remark }}</td>                                     
                <td class="text-xs-center">
                    <v-icon class="mr-2" @click="view_order( props.item.docno , props.item.date )">visibility</v-icon>
                    
                </td>
                <td class="text-xs-left">{{ props.item.status }}</td>
                </template>

            </v-data-table>

            
        </v-container>

        <v-dialog v-model="dialog" max-width="290">
            <v-card>
                <v-date-picker v-model="date"></v-date-picker>
                <v-spacer></v-spacer>
                    <v-btn block  @click="hide_dialog()" color="primary">Select</v-btn>
                    <v-btn block @click="hide_clear_dialog()" >Clear</v-btn>
            </v-card>
        </v-dialog>

    </div>
    
</template>
  
<script>
import axios from "axios"

  export default {    
        
    data() {
        return {
                /** กำหนด headers ให้ตรง */
                headers:[ 
                { text: 'Date', value: 'date' , sortable: false, },
                { text: 'Doc No.', value: 'docno' },
                { text: 'Total SKU', value: 'count_sku' },
                { text: 'Remark', value: 'remark' },
                { text: 'Actions', value: 'actions', align: 'center', sortable: false },
                { text: 'Status', value: 'status' },
                ],
                table_details:[],
                users: [],
                search: '',
                dialog : false,
                branch : '',
                date: new Date().toISOString().substr(0, 10),
                url : "https://ws.plantifulbkk.shop/images/" ,
            }
        },
        created () {

            this.read_data()
            this.branch = this.$store.getters.get_branch
        },

        methods :{
            read_data() {
                const vm = this;
                vm.axios.get('https://ws.plantifulbkk.shop/get_receive.php').then(response => {
                var result = JSON.parse(JSON.stringify(response.data))
                vm.users = result
                console.log(vm.users)
                });
            },
            show_dialog(){
                this.dialog = true
            },
            hide_dialog(){
                window.open("https://ws.plantifulbkk.shop/picklist_date_all_branch.php?date="+this.date);      
                this.dialog = false
            },
            hide_clear_dialog(){
                var date_clear = new Date().toISOString().substr(0, 10)
                this.date = date_clear
                this.dialog = false
            },
            btn_add(){
                this.$router.push('/add_production_item')
            },            
            view_order(  docno , date ){                
                this.$store.dispatch('set_date_branch_order_ac', date )
                this.$store.dispatch('set_docno_ac', docno )
                this.$router.push('/view_production')
            },
            delete_order( date , branch){

                if (window.confirm("Do you want to Delete?")) {

                    const vm = this;
                        vm.axios.get("https://ws.plantifulbkk.shop/post_del_branch_order_by_branch.php",{
                            params: {
                                scode: branch ,
                                sdate : date ,
                            }
                        }).then(result=>{
                                console.log(result.data)
                                this.read_data()
                            })
                        .catch(function (error) {
                                alert("Error")
                                console.log(error)
                            })

                    alert("Delete successfully ");
                } else {
                }    

                },

        },    
  
  }
</script>
  
<style scoped>
.v-text-field{
      width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/pages/receive_item.vue